const DEFAULT_LOADING_CLASS = "supplier-action-btn--loading";

const setButtonLoading = ($button, loadingClass = DEFAULT_LOADING_CLASS) => {
  if (!$button) return;

  const labelText = $button.textContent.replace(/\s+/g, " ").trim();
  const priorAriaLabel = $button.getAttribute("aria-label");
  $button.dataset.priorAriaLabel = priorAriaLabel === null ? "" : priorAriaLabel;
  $button.setAttribute("aria-label", labelText ? `${labelText} (processing)` : "Processing");
  $button.setAttribute("aria-busy", "true");
  $button.disabled = true;
  $button.classList.add(loadingClass);
};

const clearButtonLoading = ($button, loadingClass = DEFAULT_LOADING_CLASS) => {
  if (!$button) return;

  const { priorAriaLabel } = $button.dataset;
  if (priorAriaLabel === "") {
    $button.removeAttribute("aria-label");
  } else if (priorAriaLabel) {
    $button.setAttribute("aria-label", priorAriaLabel);
  }
  delete $button.dataset.priorAriaLabel;
  $button.removeAttribute("aria-busy");
  $button.disabled = false;
  $button.classList.remove(loadingClass);
};

export { setButtonLoading, clearButtonLoading };
